// Using a bundler like webpack
import GLightbox from 'glightbox'; 

function glightboxGallery() {
    
    // IMAGES
    const images = document.querySelectorAll('.single-property-glightbox');
    const imagesArr = Array.from(images).map((image) => {
        return {
            href: image.src ?? image.dataset.src,
            type: 'image',
        };
    });

    console.log(imagesArr);

    const galleryObj = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        elements: imagesArr,
    });

    const inViewElements = document.querySelectorAll(
        '.gallery__item .single-property-glightbox'
    );
    inViewElements?.forEach((element, index) => {
        element.addEventListener('click', () => {
            galleryObj.openAt(index);
        });
    });

    const viewAll = document.querySelector('.gallery__viewall');
    viewAll?.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        galleryObj.open();
    });

    // VIDEO
    const videos = document.querySelectorAll('.glightbox-video');
    const videosArr = Array.from(videos).map((video) => {
        const href = video.src ?? video.dataset.src;

        let source;
        if (href.includes('youtube.com') || href.includes('youtu.be')) {
            source = 'youtube';
        } else if (href.includes('vimeo.com')) {
            source = 'vimeo';
        } else {
            source = 'local';
        }

        return {
            href,
            type: 'video',
            source,
        };
    });

    const galleryVideoObj = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        elements: videosArr,
    });

    videos?.forEach((video) => {
        video.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            galleryVideoObj.open();
        });
    });

}

document.addEventListener('DOMContentLoaded', () => {

    glightboxGallery();

}); 
